import { useSearchParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { useSEO } from './useSEO';

const publishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  'pk_live_51RQZnF2N79RTloF3hOSgBRB6vYvOUfzXMRAjSxFw4dVoWgsAZuyhM4IIkibVVUwdBAW9GdaezObA4FbPXaOFza7700pCzdDx8W';
const stripePromise = loadStripe(publishableKey);
const API_BASE = ((process.env.REACT_APP_API_URL || '').replace(/\/$/, '')) || window.location.origin;

function Payment() {
  const [params] = useSearchParams();
  const level = params.get("level");
  const subject = params.get("subject");
  const board = params.get("board");
  const category = params.get("category");

  const contextLabel = [level?.toUpperCase(), subject, board].filter(Boolean).join(' ');
  const checkoutTitle = category ? `${category} checkout` : 'Checkout';

  const price = level === 'gcse' ? 60 : level === 'a-level' ? 90 : null;
  const yearsRange = '2019–2025';
  useSEO({
    title: contextLabel ? `${checkoutTitle} - ${contextLabel}` : checkoutTitle,
    description: 'Secure checkout for printed GCSE and A-Level past papers, mark schemes, and topic questions. Includes bundled exam packs for practice in proper exam conditions.',
    canonicalPath: '/payment'
  });

  const handleCheckout = async () => {
    const stripe = await stripePromise;

    const bases = Array.from(new Set([API_BASE, window.location.origin].filter(Boolean)));
    let session = null;
    let lastError = null;

    for (const base of bases) {
      try {
        const res = await fetch(`${base}/create-checkout-session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ level, subject, board, category })
        });

        if (!res.ok) {
          throw new Error(`Checkout API failed with status ${res.status}`);
        }

        session = await res.json();
        break;
      } catch (err) {
        lastError = err;
        console.error('Checkout session fetch failed for base', base, err);
      }
    }

    if (!session) {
      throw lastError || new Error('Checkout API unavailable');
    }

    await stripe.redirectToCheckout({ sessionId: session.id });
  };

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Buy Resource</h1>
      <p>You are purchasing:</p>
      <h2>{category ? `${category}` : 'Bundle'}</h2>
      <h3 style={{ marginTop: '0.25rem' }}>{level?.toUpperCase()} - {subject} {board ? `(${board})` : ''}</h3>
      {price ? (
        <p style={{ marginTop: '0.5rem', fontSize: '1.05rem', fontWeight: 600 }}>Price: £{price}</p>
      ) : (
        <p style={{ marginTop: '0.5rem', color: '#b00' }}>Select a level to see pricing.</p>
      )}
      <p style={{ marginTop: '0.75rem', maxWidth: 520, marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.4 }}>
        Includes printed copies of past papers and mark schemes from {yearsRange} so you can practise in proper exam conditions (shipping included).
      </p>

      <button
        onClick={handleCheckout}
        style={{
          marginTop: "2rem",
          padding: "12px 24px",
          backgroundColor: "#457B9D",
          color: "white",
          fontSize: "16px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer"
        }}
        disabled={!price}
      >
        {price ? `Pay £${price}` : 'Select level first'}
      </button>
    </div>
  );
}

export default Payment;
